import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
`;
Container.displayName = 'Container';

export const Time = styled.div`
  color: #9e947e;
  font-family: 'IM Fell Double Pica', serif;
  font-size: 100px;
  letter-spacing: 0.02em;
  line-height: 64px;
  margin-left: 24px;
  min-width: 360px;
`;
Time.displayName = 'Time';

export const TimeContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;
TimeContainer.displayName = 'TimeContainer';

export const Title = styled.div`
  color: #9e947e;
  font-family: 'IM Fell Double Pica', serif;
  font-size: 32px;
  letter-spacing: 0.02em;
  line-height: 64px;
  margin-bottom: 16px;
  text-align: center;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
